/** @deprecated Импортируйте из `@/lib/webmcp/forms`. */
export {
  type LeadFormFieldValues,
  webmcpParam,
  WEBMCP_PARAMS,
  leadToolName,
  leadToolDescription,
  planInquiryToolName,
  planInquiryToolDescription,
  isAgentInvokedSubmit,
  respondToAgentSubmit,
  readLeadFormValues,
  readPlanInquiryFormValues,
} from "@/lib/webmcp/forms";
